/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const InputArray = (props) => {
  const {
    type,
    label,
    name,
    options,
    value,
    setvalue,
    selectedArray,
    setselectedArray,
    error,
    onChange,
    onBlur,
    className,
    onClickList,
    required,
  } = props;

  const [displayOptions, setdisplayOptions] = useState(options);

  useEffect(() => {
    setdisplayOptions(options);
  }, [options]);

  useEffect(() => {
    if (onChange) {
      if (value || value !== "") {
        const filteredOptions = options.filter((item) => item.name.includes(value));
        setdisplayOptions(filteredOptions);
      } else {
        setdisplayOptions(options);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    setvalue("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedArray]);

  useEffect(() => {
    if (selectedArray.length === 0) {
      setdisplayOptions(options);
    } else {
      const filteredSelect = options.filter((item) => {
        let isSelected = false;
        selectedArray.forEach((selectedItem) => {
          if (selectedItem.value === item.value) {
            isSelected = true;
          }
        });

        return !isSelected;
      });

      setdisplayOptions(filteredSelect);
    }
  }, [selectedArray]);

  function onRemoveArrayItem(index) {
    const newArray = JSON.parse(JSON.stringify(selectedArray));
    newArray.splice(index, 1);
    setselectedArray(newArray);
  }

  return (
    <div autoComplete="new-password" className={`input-array ${className}`} onSubmit={(e) => e.preventDefault()}>
      <div className={`container-input-array ${value ? "active-input" : ""} ${error ? "error-input" : ""}`}>
        <div className="selected-array">
          {selectedArray.map((item, i) => (
            <div key={item.value} className="array-items">
              <p>{item.name}</p>
              <CloseIcon onClick={() => onRemoveArrayItem(i)} />
            </div>
          ))}
        </div>
        <input
          type={type ? type : "text"}
          name={name}
          list={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
          required={required}
        />
        {onChange && (
          <div
            className="btn"
            onClick={() => {
              value && setselectedArray([...selectedArray, value]);
            }}
          >
            ADD
          </div>
        )}
        {displayOptions && displayOptions.length !== 0 && (
          <div className="list">
            {displayOptions.map(
              (item, index) =>
                !selectedArray.includes(item) && (
                  <div key={item.value} className="item" onClick={() => onClickList(item)}>
                    <p>{item.name}</p>
                  </div>
                )
            )}
          </div>
        )}

        <label className={value || selectedArray.length ? "active-label" : ""}>{error ? error : label}</label>
        {/* <i className="fas fa-caret-down"></i> */}
      </div>
    </div>
  );
};

export default InputArray;
